import { useState, useMemo } from 'react'

import { Direction, Methods, SortConfig } from '../../ui/components/table/table.types'
import sortData from '../../utils/sort'

const useSortableData = <A extends Record<string, any>>(
  items: A[],
  config: SortConfig
): {
  items: A[]
  requestSort: (key: string, method: Methods) => void
  sortConfig: SortConfig
} => {
  const [sortConfig, setSortConfig] = useState(config)

  const sortedItems = useMemo(() => {
    return sortData(items, sortConfig)
  }, [items, sortConfig])

  const requestSort = (key: string, method: Methods): void => {
    let direction: Direction = 'ascending'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending'
    }
    setSortConfig({ key, direction, method })
  }

  return { items: sortedItems, requestSort, sortConfig }
}

export default useSortableData
